// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__2mG3J","homeCont":"styles_homeCont__3NQjG","backBtn":"styles_backBtn__2uozZ"};